<section class="relative flex flex-col items-center w-full">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2">
    <div>
      <h1 class="font-display text-2xl md:text-3xl font-bold text-gray-900">Paramètres</h1>
      <p class="text-gray-500 mt-1">Gérez les paramètres de votre espace expert-comptable.</p>
    </div>

    @if (loading()) {
      <article class="rounded-xl border border-gray-200 bg-white p-5 text-sm text-gray-500">Chargement...</article>
    } @else if (settings(); as s) {
      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-4">
        <h2 class="font-semibold text-gray-900 flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">apartment</span> Profil expert
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <label class="flex flex-col gap-1 md:col-span-2">
            <span class="text-xs text-gray-500">Nom du cabinet <span class="text-red-500">*</span></span>
            <input
              class="rounded-lg border border-gray-300 px-3 py-2 text-sm"
              [(ngModel)]="s.cabinetName"
              required
            >
          </label>
          <label class="flex flex-col gap-1">
            <span class="text-xs text-gray-500">Téléphone du cabinet <span class="text-red-500">*</span></span>
            <input
              class="rounded-lg border border-gray-300 px-3 py-2 text-sm"
              [(ngModel)]="s.cabinetPhone"
              required
              type="tel"
              autocomplete="tel"
              placeholder="01 23 45 67 89"
            >
          </label>
          <label class="flex flex-col gap-1">
            <span class="text-xs text-gray-500">Email du cabinet <span class="text-red-500">*</span></span>
            <input
              class="rounded-lg border border-gray-300 px-3 py-2 text-sm"
              [(ngModel)]="s.cabinetEmail"
              required
              type="email"
              autocomplete="email"
              placeholder="contact@cabinet.fr"
            >
          </label>
          <label class="flex flex-col gap-1">
            <span class="text-xs text-gray-500">Nom du contact</span>
            <input class="rounded-lg border border-gray-300 px-3 py-2 text-sm" [(ngModel)]="s.contactName">
          </label>
          <label class="flex flex-col gap-1">
            <span class="text-xs text-gray-500">Email du contact</span>
            <input class="rounded-lg border border-gray-300 px-3 py-2 text-sm" [(ngModel)]="s.contactMail">
          </label>
        </div>
        <div class="flex justify-end">
          <button class="rounded-lg bg-secondary px-4 py-2 text-white text-sm cursor-pointer" (click)="saveContact()">Enregistrer</button>
        </div>
      </article>

      <!-- Abonnement (désactivé — accès expert via paiement unique)
      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-3">
        <h2 class="font-semibold text-gray-900 flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">credit_card</span> Abonnement
        </h2>
        @if (subscriptionLoading()) {
          <p class="text-sm text-gray-500">Chargement...</p>
        } @else {
          <div class="flex items-center justify-between rounded-lg border border-gray-100 px-4 py-3">
            <div>
              <p class="text-sm font-medium text-gray-900">Plan actuel</p>
              <p class="text-lg font-bold text-secondary">{{ getPlanLabel() }}</p>
              @if (subscription()?.subscribed && subscription()?.subscriptionEnd) {
                <p class="text-xs text-gray-500 mt-1">Renouvellement le {{ getSubscriptionEndDate() }}</p>
              }
            </div>
            <div class="flex flex-col gap-2 items-end">
              @if (subscription()?.subscribed) {
                <button
                  type="button"
                  class="rounded-lg bg-secondary px-4 py-2 text-sm font-medium text-white hover:bg-secondary-hover cursor-pointer disabled:bg-secondary/50 disabled:cursor-not-allowed"
                  [disabled]="portalLoading()"
                  (click)="openCustomerPortal()"
                >
                  @if (portalLoading()) { Chargement... } @else { Gérer mon abonnement }
                </button>
              } @else {
                <a
                  routerLink="/pricing"
                  class="rounded-lg bg-secondary px-4 py-2 text-sm font-medium text-white hover:bg-secondary-hover"
                >
                  Choisir une offre
                </a>
              }
            </div>
          </div>
          @if (subscription()?.subscribed) {
            <div class="rounded-lg border border-gray-100 px-4 py-3">
              <p class="text-sm text-gray-700 mb-2">Depuis le portail Stripe, vous pouvez :</p>
              <ul class="space-y-1">
                <li class="flex items-start gap-2">
                  <span class="material-symbols-outlined text-secondary text-base mt-0.5">swap_horiz</span>
                  <span class="text-sm text-gray-600">Changer d'offre</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="material-symbols-outlined text-secondary text-base mt-0.5">credit_card</span>
                  <span class="text-sm text-gray-600">Modifier votre mode de paiement</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="material-symbols-outlined text-secondary text-base mt-0.5">receipt_long</span>
                  <span class="text-sm text-gray-600">Consulter vos factures</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="material-symbols-outlined text-secondary text-base mt-0.5">cancel</span>
                  <span class="text-sm text-gray-600">Résilier votre abonnement</span>
                </li>
              </ul>
            </div>
          } @else {
            <div class="rounded-lg border border-blue-100 bg-blue-50 px-4 py-3">
              <p class="text-sm text-blue-800">
                <a routerLink="/pricing" class="font-medium underline hover:text-blue-900">Découvrez nos offres</a>
                pour automatiser la conformité de vos clients.
              </p>
            </div>
          }
        }
      </article>
      -->
      <!--
      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-3">
        <h2 class="font-semibold text-gray-900 flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">notifications</span> Notifications
        </h2>
        <label class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
          <span class="text-sm text-gray-700">Alertes légales</span>
          <input type="checkbox" [checked]="s.legalAlertsEnabled" (change)="toggle('legalAlertsEnabled')">
        </label>
        <label class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
          <span class="text-sm text-gray-700">Alertes expiration</span>
          <input type="checkbox" [checked]="s.expiryAlertsEnabled" (change)="toggle('expiryAlertsEnabled')">
        </label>
        <label class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
          <span class="text-sm text-gray-700">Notifications email</span>
          <input type="checkbox" [checked]="s.emailNotificationsEnabled" (change)="toggle('emailNotificationsEnabled')">
        </label>
        <div class="pt-2 border-t border-gray-100">
          <p class="text-xs text-gray-500 mb-2">Activer les notifications pour les entreprises suivies</p>
          <div class="space-y-2">
            @for (entry of s.companyNotifications; track entry.siret) {
              <label class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
                <span class="text-sm text-gray-700">{{ entry.companyName }}</span>
                <input type="checkbox" [checked]="entry.enabled" (change)="toggleCompanyNotification(entry.siret)">
              </label>
            }
          </div>
        </div>
      </article>
      -->

      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-3">
        <h2 class="font-semibold text-gray-900 flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">shield</span> Sécurité
        </h2>
        <div class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
          <div>
            <p class="text-sm font-medium text-gray-900">Mot de passe</p>
            <p class="text-xs text-gray-500">Modifiez votre mot de passe de connexion</p>
          </div>
          <button
            type="button"
            class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-700 cursor-pointer hover:bg-gray-50"
            (click)="togglePasswordForm()"
          >
            @if (showPasswordForm()) { Annuler } @else { Modifier }
          </button>
        </div>
        @if (showPasswordForm()) {
          <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 space-y-3">
            <label class="flex flex-col gap-1">
              <span class="text-xs text-gray-500">Mot de passe actuel</span>
              <input
                type="password"
                class="rounded-lg border border-gray-300 px-3 py-2 text-sm"
                autocomplete="current-password"
                [value]="currentPassword()"
                (input)="currentPassword.set($any($event.target).value)"
              />
            </label>
            <label class="flex flex-col gap-1">
              <span class="text-xs text-gray-500">Nouveau mot de passe</span>
              <input
                type="password"
                class="rounded-lg border border-gray-300 px-3 py-2 text-sm"
                autocomplete="new-password"
                [value]="newPassword()"
                (input)="newPassword.set($any($event.target).value)"
              />
            </label>
            @if (newPassword().length > 0 && !isNewPasswordValid()) {
              <p class="text-xs text-red-500">
                Le mot de passe doit contenir au moins 8 caractères, une majuscule,
                une minuscule, un chiffre et un caractère spécial.
              </p>
            }
            <label class="flex flex-col gap-1">
              <span class="text-xs text-gray-500">Confirmer le nouveau mot de passe</span>
              <input
                type="password"
                class="rounded-lg border border-gray-300 px-3 py-2 text-sm"
                autocomplete="new-password"
                [value]="confirmPassword()"
                (input)="confirmPassword.set($any($event.target).value)"
              />
            </label>
            @if (confirmPassword().length > 0 && !passwordsMatch()) {
              <p class="text-xs text-red-500">Les mots de passe ne correspondent pas.</p>
            }
            <div class="flex justify-end">
              <button
                type="button"
                class="rounded-lg bg-secondary px-4 py-2 text-sm text-white cursor-pointer hover:bg-secondary-hover disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="!canSavePassword()"
                (click)="savePassword()"
              >
                @if (passwordSaving()) { Enregistrement… } @else { Enregistrer le mot de passe }
              </button>
            </div>
          </div>
        }
        <!--
        <div class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
          <div>
            <p class="text-sm font-medium text-gray-900">Authentification à deux facteurs</p>
            <p class="text-xs text-gray-500">Ajoutez une couche de sécurité supplémentaire</p>
          </div>
          <button type="button" class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-700 cursor-not-allowed bg-gray-50" disabled>
            Bientôt
          </button>
        </div>
        -->
      </article>

      <!--
      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-3">
        <h2 class="font-semibold text-gray-900 flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">language</span> Langue & région
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <span class="text-xs text-gray-500">Langue</span>
            <p class="font-medium text-gray-900">Français</p>
          </div>
          <div>
            <span class="text-xs text-gray-500">Fuseau horaire</span>
            <p class="font-medium text-gray-900">Europe/Paris (UTC+2)</p>
          </div>
        </div>
      </article>
      -->
      <!--
      <article class="rounded-xl border border-gray-200 bg-white p-5 flex items-center justify-between">
        <div>
          <h2 class="font-semibold text-gray-900 flex items-center gap-2">
            <span class="material-symbols-outlined text-secondary">key</span> API & intégrations
          </h2>
          <p class="text-xs text-gray-500 mt-1">Accédez à vos données depuis vos outils métiers.</p>
        </div>
        <button type="button" class="rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 cursor-not-allowed bg-gray-50" disabled>Générer</button>
      </article>
      -->

      <article class="rounded-xl border border-gray-200 bg-white p-5 flex items-center justify-between">
        <div>
          <h2 class="font-semibold text-gray-900">Session</h2>
          <p class="text-xs text-gray-500">Fermer la session de cet appareil.</p>
        </div>
        <button class="rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 cursor-pointer" (click)="logout()">Déconnexion</button>
      </article>
    }
  </div>
</section>
